// @ts-check
// Escolha dos campos medidos da qualidade do lead no rascunho do painel (contrato 07, seção 13.6): lista na ordem do
// catálogo, sem lista quando é o padrão do pacote (o padrão pode evoluir sem migrar a escola) e "aplicar a todos os
// cartões de qualidade do painel", para os números da aba concordarem entre si. Puro.
import {
  DEFAULT_LEAD_QUALITY_MEASURE_KEYS, LEAD_QUALITY_MEASURES, MAXIMUM_LEAD_QUALITY_MEASURES, resolveLeadQualityMeasureKeys,
} from '../../../shared/dashboards/lead-quality-measures.js';

export const LEAD_QUALITY_REPORT_KEYS = Object.freeze(['LEAD_QUALITY', 'LEAD_QUALITY_BY_ENTITY', 'LEAD_QUALITY_FIELDS', 'LEAD_QUALITY_BY_OWNER', 'LEAD_QUALITY_BY_STAGE']);

/**
 * Medidas marcadas de um cartão (sem `measures`, as do padrão), pela mesma regra do servidor: chave fora do catálogo
 * (como a retirada "CEP do contato") não conta e lista que fica vazia volta ao padrão.
 * @param {Record<string, any> | undefined} configuration
 * @returns {string[]}
 */
export function selectedMeasureKeys(configuration) {
  return [...resolveLeadQualityMeasureKeys(configuration)];
}

/**
 * Lista a gravar: na ordem do catálogo; `undefined` quando é exatamente o padrão.
 * @param {ReadonlyArray<string>} keys
 * @returns {string[] | undefined}
 */
export function normalizeMeasureSelection(keys) {
  const wanted = new Set(keys);
  const ordered = LEAD_QUALITY_MEASURES.map((measure) => measure.key).filter((key) => wanted.has(key)).slice(0, MAXIMUM_LEAD_QUALITY_MEASURES);
  const isDefault = ordered.length === DEFAULT_LEAD_QUALITY_MEASURE_KEYS.length && DEFAULT_LEAD_QUALITY_MEASURE_KEYS.every((key) => wanted.has(key));
  return isDefault ? undefined : ordered;
}

/**
 * Marca ou desmarca uma medida; a última marcada não sai (o cartão precisa de ao menos uma).
 * @param {ReadonlyArray<string>} keys @param {string} key
 */
export function toggleMeasure(keys, key) {
  if (keys.includes(key)) return keys.length > 1 ? keys.filter((item) => item !== key) : [...keys];
  return [...keys, key];
}

/**
 * Grava a escolha no cartão editado e, com "aplicar a todos", nos outros cartões de qualidade do rascunho.
 * @template {{ key: string, type: string, configuration: Record<string, any> }} TWidget
 * @param {TWidget[]} widgets @param {string} widgetKey @param {string[] | undefined} measures @param {{ applyToAll: boolean }} options
 * @returns {TWidget[]}
 */
export function applyLeadQualityMeasures(widgets, widgetKey, measures, { applyToAll }) {
  return widgets.map((widget) => {
    const isTarget = widget.key === widgetKey || (applyToAll && LEAD_QUALITY_REPORT_KEYS.includes(widget.configuration?.report));
    if (!isTarget) return widget;
    const { measures: _previous, ...rest } = widget.configuration ?? {};
    return { ...widget, configuration: measures ? { ...rest, measures: [...measures] } : rest };
  });
}
